import { render, staticRenderFns } from "./Blue.vue?vue&type=template&id=6f6f3a2c&"
import script from "./Blue.vue?vue&type=script&lang=js&"
export * from "./Blue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports